import React from 'react';
import classnames from 'classnames';
import { IAriServiceAssemblyPartProductCombinations } from '../model-viewer';
import { ProductSearchResult } from '@msdyn365-commerce/retail-proxy';
import { CommercePropertyValueEnum } from '../../../modules/allowable-freight/utils/CommercePropertyValueEnum';
import getExtensionPropertyValueByKey from '../../../utils/getExtensionPropertyValueByKey';

interface IAriRowComponent {
    part: IAriServiceAssemblyPartProductCombinations;
    baseClassName: String;
    partIdPrefix: string;
    contextNotePart: string;
    maxCharLimit: number;
    isDoNotAllowBackOrder: boolean;
    selectedRow?: string;
    isAuthenticated: boolean;
    requiresAuthentication: boolean;
    loginToViewPricingText: string;
    signInUrl: string;
    unavailableText: string;
    addToCartText: string;
    priceFormatter: (price: string | number, currencyCode?: string) => string;
    oosInvenLabel: string;
    goToId: (id: string) => void;
    addPartToCart: (part: ProductSearchResult, partId: string, partQty: number) => void;
    toggleRow: (tag: string) => void;
    expandedRows: Record<string, boolean>;
    isDrawer: boolean;
    showMoreText: string;
    showLessText: string;
}

/**
 * Component to render each table row
 * @param props props
 */
export const AriRowComponent: React.FC<IAriRowComponent> = props => {
    const {
        part,
        contextNotePart,
        maxCharLimit,
        isDoNotAllowBackOrder,
        partIdPrefix,
        baseClassName,
        goToId,
        addPartToCart,
        selectedRow,
        isAuthenticated,
        requiresAuthentication,
        loginToViewPricingText,
        signInUrl,
        unavailableText,
        addToCartText,
        priceFormatter,
        oosInvenLabel,
        toggleRow,
        expandedRows,
        isDrawer,
        showMoreText,
        showLessText
    } = props;
    const product = part.Product;
    const tag = part.PartId!;
    const full = `${contextNotePart} ${part.Context}`;
    const isLong = full.length > maxCharLimit;
    const isExpanded = Boolean(expandedRows[tag]);
    const shown = isLong && !isExpanded ? `${full.slice(0, maxCharLimit)}…` : full;
    const [quantity, setQuantity] = React.useState(1);

    const partId = product && product.ItemId;
    if (product?.ItemId === 'HOM538938002') {
        debugger;
    }
    const description = (product && product.Name) || part.Description;
    // TODO: Don't use hardcoded key
    const currentInvString =
        product && getExtensionPropertyValueByKey(product.ExtensionProperties, 'inventory', CommercePropertyValueEnum.string);
    let currentInventory = parseInt(currentInvString as string, 10);
    if (isNaN(currentInventory)) {
        currentInventory = 0;
    }
    const oosUpperBound = part.Product?.oosUpperBoundLimit || 0;
    const canAddToCart = part.Product && currentInventory > (isDoNotAllowBackOrder ? 0 : oosUpperBound) && part.Product?.isEligible;

    return (
        <tr
            key={part.PartId}
            data-part={JSON.stringify(part)}
            id={`${partIdPrefix}${part.Tag!}`}
            className={classnames(
                (selectedRow && selectedRow === part.Tag && `${baseClassName}__selected-row`) || '',
                `${baseClassName}__parts-row`
            )}
        >
            <td>
                <button className={`${baseClassName}__ref-btn__ref${isDrawer ? ' drawer-ref' : ''}`} onClick={() => goToId(part.Tag!)}>
                    {part.Tag}
                </button>
            </td>
            <td>{partId || 'N/A'}</td>
            <td>
                {description}
                {part.Context && (
                    <span className={`${baseClassName}__context-note`}>
                        <br />
                        {isLong ? (
                            <>
                                {shown}{' '}
                                <button
                                    className={`${baseClassName}__context-note__toggle-button`}
                                    onClick={() => {
                                        toggleRow(part.PartId!);
                                    }}
                                >
                                    {isExpanded ? showLessText : showMoreText}
                                </button>
                            </>
                        ) : (
                            <> {full}</>
                        )}
                    </span>
                )}
            </td>

            {isAuthenticated || !requiresAuthentication ? (
                <React.Fragment>
                    <td>{currentInventory}</td>
                    <td className={`${baseClassName}__list-price`}>{priceFormatter(part.Product?.BasePrice || 0)}</td>
                    <td>{priceFormatter(part.Product?.Price || 0)}</td>
                    {canAddToCart ? (
                        <>
                            <td className='quantity'>
                                <span className='quantity-input'>
                                    <input
                                        className='quantity-input__input'
                                        type='text'
                                        inputMode='numeric'
                                        pattern='[0-9]*'
                                        min={1}
                                        value={quantity}
                                        disabled={!part.Product}
                                        onChange={e => {
                                            const raw = e.target.value.replace(/\D/g, '');
                                            const parsed = parseInt(raw || '1', 10);
                                            setQuantity(Math.max(1, parsed));
                                        }}
                                    />
                                </span>
                            </td>
                            <td>
                                {' '}
                                <button
                                    className={`${baseClassName}__ref-btn add-to-cart-btn`}
                                    onClick={() => addPartToCart(part.Product!, part.PartId!, quantity)}
                                >
                                    {addToCartText}
                                </button>
                                <p className={`hide-status hide-status-${part.PartId}`}></p>
                            </td>
                        </>
                    ) : (
                        <>
                            <td></td>
                            <td>
                                <span className={`${baseClassName}__ref-btn disabled`}>
                                    {isDoNotAllowBackOrder && oosUpperBound < 0 ? oosInvenLabel : unavailableText}
                                </span>{' '}
                            </td>
                        </>
                    )}
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <td>{currentInventory}</td>
                    <td>{priceFormatter(part.Product?.BasePrice || 0)}</td>
                    <td>
                        <a href={signInUrl}>{loginToViewPricingText}</a>
                    </td>
                </React.Fragment>
            )}
        </tr>
    );
};

export default AriRowComponent;
